import React from 'react';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import Tag from '@atlaskit/tag';
import { getTagDisplayName } from '@app/app-updates-table-filters/src/constants';
import type { UpdateType } from '@app/app-updates/src/schema';

const tagsContainerStyles = xcss({
  maxWidth: '160px',
});

export interface UpdateTagsProps {
  tags?: UpdateType['tags'];
}

export const UpdateTags: React.FC<UpdateTagsProps> = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Box xcss={tagsContainerStyles}>
      <Inline space="space.050" shouldWrap>
        {tags.map((tag) => (
          <Tag
            key={tag}
            text={getTagDisplayName(tag)}
            color="standard"
            isRemovable={false}
          />
        ))}
      </Inline>
    </Box>
  );
};
